import type { ReactNode } from 'react';
import { Option } from './Controls';

export interface ListOption {
  value: string;
  title: ReactNode;
  description?: ReactNode;
}

/**
 * Список вариантов под полем внутри модального окна (стиль модуля M2
 * `.olist`): радио-строки `.opt.rad`. Заменяет поповер там, где поповер
 * нельзя — в окне (CLAUDE.md, «Интерфейс»).
 */
export function OptionList({
  options,
  value,
  onChange,
}: {
  options: ListOption[];
  value: string | null;
  onChange: (value: string) => void;
}) {
  if (!options.length) return null;
  return (
    <div className="olist">
      {options.map((o) => (
        <Option
          key={o.value}
          radio
          checked={o.value === value}
          onToggle={() => onChange(o.value)}
          title={o.title}
          description={o.description}
        />
      ))}
    </div>
  );
}

/** Подсказка под полем в окне: «Начните вводить — покажем совпадения.» */
export function FieldHint({ children, gap }: { children: ReactNode; gap?: boolean }) {
  return <p className={gap ? 'fh2 gap' : 'fh2'}>{children}</p>;
}
